import GetStartedBox from '@/components/GetStartedBox';
import { BsFlag, FiBook, GoLinkExternal, PiSlackLogo } from '@/components/react-icons/main';
import { useArgSelector } from '@/redux/curriedSelectors/curriedSelectors';
import { query as querySelector } from '@/redux/selectors/querySelectors';
import { useUser } from '@clerk/clerk-react';

const LoginIframe = ({ title = 'Finish setting up Mindcloud', message = 'Click on Continue to finish setting up MindCloud for your account.', showSupportLinks = true }) => {
  const user = useUser();
  const isAuthenticated = !!user?.jwt?.id;
  const query = useArgSelector(querySelector);

  const handleExternalLinkClick = () => {
    const hasOAuthSignupParams = !!(query?.tempCompanyId || query?.bundleId);

    if (hasOAuthSignupParams) {
      const signupParams = new URLSearchParams();
      if (query?.tempCompanyId) {
        signupParams.set('tempCompanyId', query.tempCompanyId);
      }
      if (query?.bundleId) {
        signupParams.set('bundleId', query.bundleId);
      }
      window.open(`/signup?${signupParams.toString()}`, '_blank').focus();
    } else {
      const url = isAuthenticated ? window.location.href : `${window.location.href}&from=${window.location.pathname}`;
      window.open(url, '_blank').focus();
    }
  };

  const handleSlackClick = () => {
    window.open('https://join.slack.com/t/mindcloudusers/shared_invite/zt-2s88hy60h-MFNJeWSzYtrlMFUl8MN1zg', '_blank').focus();
  };

  const handleDocsClick = () => {
    window.open('https://mindcloud.co/docs', '_blank').focus();
  };

  return (
    <div className={`login-v2-screen iframe`}>
      <GetStartedBox
        icon={BsFlag}
        title={title}
        message={message}
        actions={[
          {
            label: 'Continue',
            icon: GoLinkExternal,
            onClick: handleExternalLinkClick,
            className: 'primary'
          },
          ...(showSupportLinks
            ? [
                {
                  label: 'Documentation & User Guides',
                  icon: FiBook,
                  onClick: handleDocsClick,
                  className: 'secondary'
                },
                {
                  label: 'Slack Community',
                  icon: PiSlackLogo,
                  onClick: handleSlackClick,
                  className: 'secondary'
                }
              ]
            : [])
        ]}
      />
    </div>
  );
};

export default LoginIframe;
